import React from 'react';
// import dateFns from 'date-fns';
import * as dateFns from 'date-fns';
import { format, isValid } from 'date-fns';
import { Link } from 'react-router-dom';

import pt from 'date-fns/locale/pt';
import Typography from '@material-ui/core/Typography';
import MessageIcon from '@material-ui/icons/AssignmentLate';
import Done from '@material-ui/icons/Done';
import Clear from '@material-ui/icons/Clear';
import WorkOff from '@material-ui/icons/WorkOff';
import moment from 'moment';
import { getMinutes, getHours } from 'date-fns';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import classNames from 'classnames';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';
import Icon from '@material-ui/core/Icon';
import Menu from '@material-ui/core/Menu';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Input from '../../components/Input/Input';
import { createVacations } from '../../store/actions/vacation';
import { setMessage } from '../../store/actions/general';
import ActionsList from './ActionsList';
import DayHours from './../DayHours/DayHours';
import DaysHoursOff from './../DayHours/DaysHoursOff';
import axios from '../../config/axiosInstance';
import AlertDialog from '../../components/AlertDialog/AlertDialog';
import ErrorOutline from '@material-ui/icons/ErrorOutline';
import { Map, Marker, TileLayer, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import redMarker from '../../assets/images/Marker/redMarker.png';
import greenMarker from '../../assets/images/Marker/greenMarker.png';
import blueMarker from '../../assets/images/Marker/blueMarker.png';
import CircularProgress from '@material-ui/core/CircularProgress';


const styles = theme => ({
  fab: {
    right: '-30px',
    position: 'absolute',
    bottom: '-30px',
  },
  abonoBtn: {
    bottom: '30px',
    backgroundColor: '#2c7b2c',
    right: '-30px',
    position: 'absolute',
  },
  validateBtn: {
    bottom: '90px',
    backgroundColor: 'blue',
    right: '-30px',
    position: 'absolute',
  },
  msgMargin: {
    fontSize: '13px',
    marginLeft: '5px',
  },
  finishActionsButton: {
    // marginTop: '15px',
    // position: 'absolute',
    // top: '9px',
    // right: '12px',
    margin: 'auto',
  },
  basis50: {
    flexBasis: '50%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '100%',
  },
  dense: {
    marginTop: 19,
    marginLeft: 0,
  },
  timeInputContainer: {
    flexDirection: 'column',
    marginTop: '20px',
  },
  timeSpan: {
    color: '#0000008a',
  },
  timeInput: {
    marginLeft: '10px',
  },
  refHourContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  },
  refHour: {
    margin: 'auto',
  },
  infoDetails: {
    display: 'flex',
    flexDirection: 'column',
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: '1em',
  },
  messagesContainer: {
    flexDirection: 'column',
    display: 'flex',
    color: 'red',
  },
  messagemAlert: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  quadColumnContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  quadContentColumn: {
    flexBasis: '49%',
  },
  lightTooltip: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 16,
  },
  warningContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  warningSpan: {
    padding: '15px',
  },
  hide: {
    display: 'none !important',
  },
  speedDial: {
    position: 'absolute',
    bottom: '-25px',
    right: '0',
  },
  speedDialAction: {
    color: '#537ccd !important',
    backgroundColor: 'white !important',

    '&:hover': {
      color: 'white !important',
      backgroundColor: '#537ccd !important',
    },
  },
  premium: {
    fontWeight: theme.typography.fontWeightStrong,
  },
});
const iconIn = Leaflet.icon({
  iconUrl: greenMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

const iconOut = Leaflet.icon({
  iconUrl: redMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});
const iconAllowed = Leaflet.icon({
  iconUrl: blueMarker,
  iconAnchor: [13.5, 41],
  popupAnchor: [0, -41], // point from which the popup should open relative to the iconAnchor
});

class CalendarModalContent extends React.Component {
  state = {
    openConfirm: false,
    newTime: '', // add ponto
    justification: '', // add ponto,
    openAdd: false, // addponto,
    openAddButtomDisable: false, // addponto,
    type: '', // addponto
    openAbono: false,
    openValidate: false,
    dialOpen: false,
    anchorEl: null,
    hideConfirmButton: false,
    category: '',
    observation: null,
    compensationDate: null,
    allowanceHours: null,
    isEmpty: null,
    premium: false,
    modalPicture: false,
    fotoModal: '',
    namePicture: '',
    dataPicture: '',
    hourPicture: '',
    typePicture: '',
    openDialogPicture: false,
    errorPicture: false,
    error: false,
    validaetPremium: JSON.parse(localStorage.getItem('privileges')).isExportAfd,
    latitude: '',
    longitude: '',
    Type: null,
    expectedRule: '',
    reduces: '',
    homeOffice: '',
    valueObservation: '',
    loading: false,
    buttonConfirm: true
  }

  componentWillReceiveProps() {
    this.actions = [];
    this.forceUpdate();
  }

  actions = [];
  entradas = [];
  saidas = [];
  warningMessages = [];
  escala = [];
  entradasOff = [];
  saidasOff = [];
  isEmpty = [];

  handleConfirmClose = () => {
    this.setState({ openConfirm: false });
  };

  modalPicture = async (value) => {
    if (this.state.validaetPremium) {
      if (!this.state.modalPicture) {
        axios({
          url: 'timeclocks/photo',
          data: {
            timeclockId: value.id
          },
          method: 'POST',
          responseType: 'blob', // important
        })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('show', '{file}.jpeg'); //or any other extension
            document.body.appendChild(link);
            this.setState({ modalPicture: true });
            this.setState({ fotoModal: link })
            this.preenchePictureModal(value);
          })
          .catch((error) => {
            this.errorPictureOpen(value)
          });
      } else {
        this.setState({ modalPicture: false });
      }
    } else {
      this.setState({ openDialogPicture: true });
    }
  };

  downloadPicture = (value) => {
    if (value) {
      value.setAttribute('download', `${this.state.namePicture}-${(moment(this.state.dataPicture, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))}-${this.state.hourPicture}-${this.state.typePicture == 'I' ? 'Entrada' : 'Saida'}.jpeg`);
      document.body.appendChild(value);
      value.click();
    }
  }

  preenchePictureModal = (value) => {
    this.setState({ namePicture: this.props.worker.name });
    this.setState({ dataPicture: this.props.detailed.typeDay.dtRef });
    this.setState({ hourPicture: value.data });
    this.setState({ typePicture: value.type });
    this.setState({ error: false });
    this.setState({ latitude: value.lat });
    this.setState({ longitude: value.lng });
    this.setState({ Type: value.type });
  }


  onCloseModalPicture = () => {
    this.setState({ openDialogPicture: false });
  }

  errorPictureOpen = (value) => {
    this.setState({ errorPicture: true });
    this.setState({ error: true });
    this.setState({ latitude: value.lat });
    this.setState({ longitude: value.lng });
    this.setState({ Type: value.type });
  }

  errorPictureClose = () => {
    this.setState({ errorPicture: false });
  }

  handleAddClose = () => {
    this.setState({ openAdd: false });
  };

  handleAbonoClose = () => {
    this.setState({
      openAbono: false, category: '', observation: null, compensationDate: null, allowanceHours: null, reduces: '', homeOffice: ''
    });
  };

  editHour = (h) => {
    const action = {
      action: 'SUB',
      id: h.id,
      type: h.type,
      dtRegister: dateFns.format(h.newDT, 'yyyy-MM-dd HH:mm'),
      justification: h.newJustification,
      isRemake: h.isRemake,
    };

    this.actions.push(action);
    this.forceUpdate();
  }

  asCheckpoint = (h) => {
    const action = {
      action: "CHECK",
      isCheckPoint: h.isCheckPoint,
      dtRegister: h.dtRegister,
      id: h.id,
      isRemake: h.isRemake,
    }

    this.actions.push(action);
    this.forceUpdate();
  }

  handleChange = (event) => { // add ponto
    this.setState({ newTime: event.target.value });
  }

  handleTypeChange = (event) => { // add ponto
    this.setState({ type: event.target.value });
  }

  handleJustificationChange = (event) => { // add ponto
    this.setState({ justification: event.target.value });
  }

  formatNewPontoDate = () => { // ponto
    const dayRef = this.props.detailed.typeDay.dtRef;
    const hora = this.state.newTime.slice(0, 2);
    const minuto = this.state.newTime.slice(3, 5);
    const newDT = new Date(dayRef.slice(0, 4), dayRef.slice(5, 7) - 1, dayRef.slice(8, 10), hora, minuto);
    return newDT;
  }

  add = () => {
    this.setState({
      openAdd: true, hideConfirmButton: false, anchorEl: null, newTime: '', justification: '', type: ''
    });
  }

  confirmAdd = () => {
    this.setState({ openAddButtomDisable: true })
    this.formatNewPontoDate();
    const action = {
      action: 'ADD',
      type: this.state.type,
      dtRegister: dateFns.format(this.formatNewPontoDate(), 'yyyy-MM-dd HH:mm'),
      justification: this.state.justification,
    };
    this.actions = [];
    this.actions.push(action);
    // this.finishActions();

    this.forceUpdate();
    this.setState({ openAdd: false })
  }

  addPonto = () => {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.state.openAdd}
        onClose={this.handleAddClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Adicionar Ponto</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Informe o horário para o novo ponto.
          </DialogContentText>
          <div className={classNames(classes.timeInputContainer, 'display-flex')}>
            <span className={classNames(classes.basis50, classes.timeSpan)}>
              Novo horário:
              <input
                className={classes.timeInput}
                type="time"
                value={this.state.newTime}
                onChange={this.handleChange}
              />
            </span>

            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-simple">Tipo</InputLabel>
              <Select
                required
                value={this.state.type}
                onChange={this.handleTypeChange}
                inputProps={{
                  name: 'type',
                  id: 'ponto-type',
                }}
              >
                <MenuItem value="I">Entrada</MenuItem>
                <MenuItem value="O">Saída</MenuItem>
              </Select>
            </FormControl>

            <TextField
              required
              label="Justificativa"
              value={this.state.justification}
              onChange={this.handleJustificationChange}
              className={classNames(classes.textField, classes.dense)}
              margin="dense"
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleAddClose}>CANCELAR</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!this.state.justification.length || !this.state.newTime || !this.state.type || this.state.openAddButtomDisable}
            onClick={() => this.confirmAdd()}
          >
            CONFIRMAR
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderMessages() {
    if ((this.props.detailed.messagesDivergents && this.props.detailed.messagesDivergents.length) || this.props.detailed.messageDivergence) {
      const messages =
        this.props.detailed.messagesDivergents || [this.props.detailed.messageDivergence];

      const displayMessages = messages.map(m => <div className={this.props.classes.messagemAlert} > <MessageIcon style={{ color: 'yellow' }} /> <span className={this.props.classes.msgMargin}>{m.slice(7)}</span></div>);

      return displayMessages;
    }

    // return <span>Nenhuma divergência encontrada</span>;
    return <span />;
  }

  renderHours(hours) {
    this.something = '';
    if (hours && hours.tms.length >= 1) {
      return hours.tms.map((h, i) => (
        <div>
          <span style={{ color: 'blue' }}>
            {dateFns.format(new Date(new Date(hours.tms[i].dtRegister).getTime() +
              (new Date(hours.tms[i].dtRegister).getTimezoneOffset() * 60000)), 'HH:mm:ss')}
          </span>
          <div className="action-buttons">
            <span>
              add
            </span>
            <span>
              edit
            </span>
          </div>
          <br />
        </div>));
    }
    return <div />;
  }

  renderFinish = () => {
    if (this.actions.length && !this.state.hideConfirmButton) {
      return (
        <div style={{ width: '100%', display: 'flex' }}>
          <Button
            className={this.props.classes.finishActionsButton}
            variant="contained"
            color="primary"
            // onClick={() => this.setState({ openConfirm: true })}
            onClick={() => this.state.loading ? '' : this.finishActions()}
          >
            {
              this.state.loading ? <CircularProgress size={20} color="white" /> : 'Salvar Alterações'
            }
          </Button>
        </div>
      );
    }
    return <div />;
  }

  renderConfirm = () => (
    <Dialog
      open={this.state.openConfirm}
      onClose={this.handleConfirmClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Confirmar Alterações</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Deseja prosseguir com as seguintes modificações?
        </DialogContentText>
      </DialogContent>
      <ActionsList
        actions={this.actions}
        undoAction={this.undoAction}
      />
      <DialogActions>
        <Button onClick={this.handleConfirmClose}>CANCELAR</Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => this.finishActions()}
        >
          CONFIRMAR
        </Button>
      </DialogActions>
    </Dialog>
  )

  finishActions = () => {
    this.setState({ loading: true })
    axios
      .post('timeSheet/actions', {
        employeeId: this.props.worker.id,
        actions: this.actions,
      })
      .then((response) => {
        this.handleConfirmClose();
        this.handleAbonoClose();
        this.handleValidateClose();
        this.handleFaltaClose();
        this.setState({ openAdd: false, hideConfirmButton: false, openAddButtomDisable: false });
        this.setState({ loading: false })
        this.props.close();
      })
      .catch((error) => {
        this.props.onMessage(error);
        this.setState({ openAddButtomDisable: false });
      });
  }

  escalaDetailsText = (escala) => {
    if (!escala.length) {
      return null;
    }

    let text = ' ';

    escala.forEach((i, index) => {
      const isEven = index % 2 === 0;

      if (isEven) {
        text += ` ${i} a `;
      } else {
        text += i;
        if (index !== escala.length - 1) {
          text += ' | ';
        }
      }

      return i;
    });

    return text;
  }

  checkDismiss = () => {
    const { worker } = this.props;
    let warning = false;
    if (worker && worker.isfired && this.props.detailed && this.props.detailed.typeDay) {
      const start = worker.dtdemission;
      const end = worker.dtlastdaywork;
      const day = this.props.detailed.typeDay.dtRef;

      // dateFns.format(new Date(), 'yyyy-MM-dd');
      // const date = dateFns.parse(currentDate, 'yyyy-MM-dd', new Date());
      // const dayMonth = dateFns.format(date, 'dd', { locale: pt });

      if (day >= start && day <= end) {
        warning = true;
      } else {
        warning = false;
      }

      return warning;
    }
  }

  renderDayDetails = () => {
    const { classes } = this.props;
    const type = this.props.detailed.obs;
    let fullType = '';

    if (type === 'COM') {
      fullType = 'Comum';
    }

    if (type === 'FAL') {
      fullType = 'Falta';
    }

    if (type === 'FOL') {
      fullType = 'Folga';
    }

    if (type === 'ABO/FER') {
      fullType = 'Férias';
    }

    if (type === 'ABO/HOL') {
      fullType = 'Feriado';
    }

    if (type === 'ABO/FJ') {
      fullType = 'Falta justificada';
    }

    if (type === 'ABO/LIC') {
      fullType = 'Licença/Afastamento';
    }

    if (type === 'COMP DE DOM/FRD') {
      fullType = 'COMP DE DOM/FRD';
    }

    if (type === 'FAL/ABONO DE HORAS') {
      fullType = 'Falta com abono de horas';
    }

    if (type === 'COM/ABONO DE HORAS') {
      fullType = 'Comum com abono de horas';
    }

    if (type === 'FAL CONFIRMED') {
      fullType = 'Falta';
    }

    // if (type === '?') {
    //   fullType = 'Falta sem justificativa';
    // }

    return (
      <div>
        {/* <div>
          {dayWeek}, {dayMonth} de {month} de {year}
        </div> */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography variant="body1" style={{ lineHeight: 1.75 }}>Tipo do dia: <span style={{ color: 'black' }}>{fullType || 'Comum'}</span></Typography>

          {
            this.checkDismiss() ?
              <Tooltip
                style={{ color: '#ffcc33', fontSize: '20px' }}
                // className={`${ !this.warningMessages.length ? classes.hide : '' } `}
                classes={{ tooltip: classes.lightTooltip }}
                title="Em desligamento"
                aria-label="desligamento"
                placement="top"
              >
                <WorkOff />
              </Tooltip> :
              <Tooltip
                style={{ color: '#e00000', fontSize: '20px', marginLeft: 5 }}
                className={`${!this.warningMessages.length ? classes.hide : ''} `}
                classes={{ tooltip: classes.lightTooltip }}
                title={this.renderWarnings()}
                aria-label="Divergências"
                placement="top"
              >
                <Icon>warning</Icon>
              </Tooltip>

          }
        </div>
        <div className={`${!this.escala.length ? classes.hide : ''} `}>
          {/* Escala: { this.escala[0] + ' a ' + this.escala[1] + ' | ' + this.escala[2] + ' a ' + this.escala[3]} */}
          <Typography variant="body1" style={{ lineHeight: 1.7 }}>Escala: <span style={{ color: 'black' }}>{this.escalaDetailsText(this.escala)}</span></Typography>
        </div>
      </div>
    );
  }

  renderTitle = () => {
    const currentDate = this.props.detailed.typeDay ? this.props.detailed.typeDay.dtRef : dateFns.format(new Date(), 'yyyy-MM-dd');
    const date = dateFns.parse(currentDate, 'yyyy-MM-dd', new Date());
    const dayMonth = dateFns.format(date, 'dd', { locale: pt });
    const month = dateFns.format(date, 'MMMM', { locale: pt });
    const year = dateFns.format(date, 'yyyy', { locale: pt });

    return (
      <div
        style={{
          display: 'flex', alignItems: 'center', position: 'relative', marginBottom: '1em',
        }}
      >
        {/* {dayWeek}, {dayMonth} de {month} de {year} */}
        <Typography variant="body1" style={{ margin: 'auto', fontWeight: 600 }}>{dayMonth} de {month} de {year}</Typography>
        {this.renderMenu()}
      </div>
    );
  }


  buildDataInfo = () => {
    this.entradas = [];
    this.saidas = [];
    this.escala = [];
    this.entradasOff = [];
    this.saidasOff = [];
    this.isEmpty = [];

    if (this.props.detailed.ins && this.props.detailed.outs) {
      this.props.detailed.ins.map(timeclock => this.entradas.push(timeclock));
      this.props.detailed.outs.map(timeclock => this.saidas.push(timeclock));
    }

    if (this.props.detailed.insOffline && this.props.detailed.outsOffline) {
      this.props.detailed.insOffline.map(timeclock => this.entradasOff.push(timeclock));
      this.props.detailed.outsOffline.map(timeclock => this.saidasOff.push(timeclock));
    }

    if (this.props.detailed.settings && this.props.detailed.settings.work) {
      this.escala = this.props.detailed.settings.work._scale[0].split(',');
    }
  }

  buildMessages = () => {
    this.warningMessages = [];

    if (this.props.detailed && this.props.detailed.divergences && this.props.detailed.divergences.genericMessages) {
      this.props.detailed.divergences.genericMessages.map(m => this.warningMessages.push(m.message));
    }
  }

  renderWarnings = () => {
    const { classes } = this.props;
    this.buildMessages();

    const content = this.warningMessages.map(m => <span className={classNames(classes.warningSpan)}>{m}</span>);

    return (
      <React.Fragment>
        <div className={classNames(classes.warningContainer)}>
          {content}
        </div>
      </React.Fragment>
    );
  }

  handleClick = (event) => {
    if (!this.props.detailed.mock) {
      this.setState({ anchorEl: event.currentTarget });
    }
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  renderMenu = () => {
    const { anchorEl } = this.state;
    const { detailed } = this.props;
    const insoutsEmpty = detailed && (this.entradas.length || this.saidas.length) === 0;
    const insoutsOffEmpty = detailed && (this.entradasOff.length || this.entradasOff.length) === 0;
    return (
      <div data-tut="reactour__MoreInfo" style={{ position: 'absolute', right: 0 }} >
        <IconButton
          aria-label="Opções"
          aria-owns={anchorEl ? 'simple-menu' : undefined}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleMenuClose}
        >
          <MenuItem onClick={() => this.add()}>Adicionar Ponto</MenuItem>
          <MenuItem onClick={() => this.setState({
            justification: '', openAbono: true, hideConfirmButton: true, anchorEl: null, category: '', observation: '', compensationDate: null, allowanceHours: null,
          })}
          >
            Abonar Dia
          </MenuItem>
          {insoutsEmpty && insoutsOffEmpty ? <MenuItem
            style={{ cursor: 'not-allowed', opacity: 0.6 }}
          >
            Validar Pontos
          </MenuItem> :
            <MenuItem
              onClick={() => this.setState({
                justification: '', openValidate: true, hideConfirmButton: true, anchorEl: null,
              })}
            >
              Validar Pontos
            </MenuItem>

          }

          <MenuItem onClick={() => this.setState({
            justification: '', openFalta: true, hideConfirmButton: true, anchorEl: null,
          })}
          >
            Marcar Falta
          </MenuItem>
        </Menu>
      </div>
    );
  }


  handleDialClick = () => {
    this.setState(state => ({
      dialOpen: !state.dialOpen,
    }));
  };

  handleDialClose = () => {
    this.setState({ dialOpen: false });
  };

  handleDialOpen = () => {
    this.setState({ dialOpen: true });
  };

  fixTimestamp(date) {
    return new Date(new Date(date).getTime() + (new Date(date).getTimezoneOffset() * 60000));
  }

  remove = (ponto) => {
    const action = {
      action: 'REM',
      category: ponto.category,
      categoryRemake: ponto.category ? ponto.category : '',
      id: ponto.id,
      justification: ponto.newJustification,
      isRemake: ponto.isRemake,
      dtRegister: this.fixTimestamp(ponto.dtRegister),
    };

    this.actions.push(action);
    this.forceUpdate();
  }

  aproveOff = (ponto) => {
    const action = {
      action: 'OFF',
      id: ponto.id,
      isRemake: ponto.isRemake,
      dtRegister: this.fixTimestamp(ponto.dtRegister),
    };

    this.actions.push(action);
    this.forceUpdate();
  }


  abonar = () => {
    this.actions = [];

    const action = {
      action: 'ABO',
      dtRegister: this.props.detailed.typeDay.dtRef,
      justification: this.state.justification,
    };

    this.actions.push(action);
    this.finishActions();
    this.forceUpdate();
  }

  generateValidateAction = (quadrante) => {
    this.props.detailed.ins.map((ponto) => {
      const action = {
        action: 'VAL',
        id: ponto.id,
        isDiscrepance: true,
        justification: this.state.justification,
        isRemake: ponto.isRemake,
        dtRegister: this.fixTimestamp(ponto.dtRegister),
      };
      this.actions.push(action);
      return ponto;
    });

    this.props.detailed.outs.map((ponto) => {
      const action = {
        action: 'VAL',
        id: ponto.id,
        isDiscrepance: true,
        justification: this.state.justification,
        isRemake: ponto.isRemake,
        dtRegister: this.fixTimestamp(ponto.dtRegister),
      };
      this.actions.push(action);
      return ponto;
    });
  }

  validate = () => {
    this.actions = [];
    this.generateValidateAction();

    this.finishActions();
    this.forceUpdate();
  }

  expectedRule = () => {

    if (this.state.category === 'ALLOWANCE_HOURS' ||
      this.state.category === 'JUSTIFIED_DELAY' ||
      this.state.category === 'OUTPUT_SERVICE') {
      return 'REDUCE_EXPECTED_WORKING'
    }

    if (this.state.category === 'MISSING_TIME') {
      this.setState({ expectedRule: 'MISSING_TIME' })
    }

    if (this.state.category === 'VACATION' ||
      this.state.category === 'JUST_ABS' ||
      this.state.category === 'OPTIONAL_DAY' ||
      this.state.category === 'WORK_LEAVE' ||
      this.state.category === 'LEAVE_OF_ABSENCE') {
      return null
    }

    if (this.state.category === 'CHANGE_DAY') {
      return 'CHANGE_DAY'
    }

    if (this.state.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION') {
      return 'COMP_SUN_FRD'
    }

    if (this.state.category === 'OUT_JUST_ABSENCE') {
      return 'OUT_JUST_ABSENCE'
    }

    if (this.state.category === 'BANK_HOURS_COMPENSATION') {
      return 'REDUCE_BANK_HOURS'

    }

    if (this.state.category === 'DECLARATION_ATTENDANCE') {
      return this.state.reduces
    }

    if (this.state.category === 'HOME_OFFICE') {
      return this.state.homeOffice
    }
  }

  handleInputChange = (event, type) => {
    // let newCompensation = { ...this.state.compensationDate };
    let newallowanceHours = { ...this.state.allowanceHours };

    switch (type) {
      case 'category':
        if (event.target.value == 'JUST_ABS' ||
          event.target.value == 'OPTIONAL_DAY' ||
          event.target.value == 'WORK_LEAVE' ||
          event.target.value == 'LEAVE_OF_ABSENCE' ||
          event.target.value == 'OUT_JUST_ABSENCE' ||
          event.target.value == 'BANK_HOURS_COMPENSATION' ||
          event.target.value == 'HOME_OFFICE'
        ) {
          this.setState({ buttonConfirm: true, observation: '', allowanceHours: null, compensationDate: null, reduces: '', homeOffice: '' })
        } else {
          this.setState({ buttonConfirm: false, observation: '', allowanceHours: null, compensationDate: null, reduces: '', homeOffice: '' })
        }
        this.setState({ category: event.target.value });
        break;

      case 'observation':
        this.setState({ observation: event.target.value });
        break;

      case 'compensationDate':
        this.setState({ compensationDate: event && isValid(event) ? event : null, buttonConfirm: true });
        break;

      case 'allowanceHours':
        newallowanceHours = event;
        this.setState({ allowanceHours: newallowanceHours, buttonConfirm: true });
        break;

      default:
        break;
    }

  };

  renderConfirmAbono = () => {
    const types = [
      // { value: 'VACATION', displayValue: 'FÉRIAS' },
      { value: 'JUST_ABS', displayValue: 'FALTA JUSTIFICADA' },
      { value: 'OPTIONAL_DAY', displayValue: 'PONTO FACULTATIVO' },
      { value: 'WORK_LEAVE', displayValue: ' DIA DE FOLGA' },
      { value: 'LEAVE_OF_ABSENCE', displayValue: 'LICENÇA/AFASTAMENTO' },
      { value: 'SUNDAY_OR_HOLIDAY_COMPENSATION', displayValue: 'COMPENSAÇÃO DE DOMINGO/FERIADO' },
      { value: 'ALLOWANCE_HOURS', displayValue: 'ABONO DE HORAS' },
      { value: 'OUT_JUST_ABSENCE', displayValue: 'FALTA SEM JUSTIFICATIVA' },
      { value: 'JUSTIFIED_DELAY', displayValue: 'ATRASO JUSTIFICADO' },
      { value: 'OUTPUT_SERVICE', displayValue: 'SAIDA Á SERVIÇO' },
      { value: 'DECLARATION_ATTENDANCE', displayValue: 'DECLARAÇÃO DE COMPARECIMENTO' },
      { value: 'BANK_HOURS_COMPENSATION', displayValue: 'COMPENSAR NO BANCO DE HORAS' },
      { value: 'MISSING_TIME', displayValue: 'HORA FALTA' },
      { value: 'HOME_OFFICE', displayValue: 'HOME OFFICE' },
      { value: 'CHANGE_DAY', displayValue: 'TROCA DE FOLGA' }
    ];

    const typesReduce = [
      { value: 'REDUCE_EXPECTED_WORKING', displayValue: 'Abonar horas' },
      { value: 'REDUCE_BANK_HOURS', displayValue: 'Compensar no banco de horas ' }
    ]

    const typesHome = [
      { value: 'TOTAL_WORKING_EQUAL_EXPECTED', displayValue: 'Carga horária conforme escala de trabalho atual' },
      { value: 'NONE', displayValue: 'Carga horária pré-assinalada da escala de trabalho atual' }
    ]

    const observations = [
      { value: 'AFASTAMENTO PELO INSS', displayValue: 'AFASTAMENTO PELO INSS' },
      { value: 'LICENÇA MATERNIDADE', displayValue: 'LICENÇA MATERNIDADE' },
      { value: 'ATESTADO MÉDICO', displayValue: 'ATESTADO MÉDICO' },
      { value: 'DECLARAÇÃO DE ÓBITO', displayValue: 'DECLARAÇÃO DE ÓBITO' },
      { value: 'LICENÇA PATERNIDADE', displayValue: 'LICENÇA PATERNIDADE' },
      { value: 'LICENÇA POR CASAMENTO', displayValue: 'LICENÇA POR CASAMENTO' },
      { value: 'LICENÇA AMAMENTAÇÃO', displayValue: 'LICENÇA AMAMENTAÇÃO' },
      // { value: 'outro', displayValue: 'outro' }
    ]

    return (
      <React.Fragment>
        <Dialog
          open={this.state.openAbono}
          onClose={this.handleAbonoClose}
        >
          <DialogTitle>
            Cadastrar abono
          </DialogTitle>

          <DialogContent>
            <DialogContentText>
              Informe os dados para cadastro de folgas, faltas justificadas ou licenças
            </DialogContentText>
            <div style={{ width: '400px' }}>
              <Input
                elementType="select"
                value={this.state.category ? this.state.category : ''}
                onChange={event => this.handleInputChange(event, 'category')}
                label="Tipo"
                options={types}
                margin="normal"
                required
                fullWidth
              />
            </div>
            <div>
              <div style={{ width: '400px' }}>
                {
                  this.state.category === 'LEAVE_OF_ABSENCE' ? '' :

                    <Input
                      elementType="input"
                      value={this.state.observation}
                      onChange={event => this.handleInputChange(event, 'observation')}
                      type="text"
                      label="Observação"
                      margin="normal"
                      fullWidth
                    />
                }
              </div>
              {this.state.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION' ? (
                <Input
                  elementType="datePicker"
                  label="Domingo/feriado trabalhado"
                  margin="normal"
                  value={this.state.compensationDate || null}
                  onChange={event => this.handleInputChange(event, 'compensationDate')} />) :
                this.state.category === 'ALLOWANCE_HOURS' ?
                  <Input
                    elementType="timePicker"
                    label="Horas abonadas"
                    margin="normal"
                    value={this.state.allowanceHours ? this.state.allowanceHours : null
                    }
                    onChange={event => this.handleInputChange(event, 'allowanceHours')}
                  /> : null}
              {this.state.category === 'CHANGE_DAY' ? (
                <Input
                  elementType="datePicker"
                  label="TROCA DE FOLGA"
                  margin="normal"
                  value={this.state.compensationDate || null}
                  onChange={event => this.handleInputChange(event, 'compensationDate')} />) :
                null}
              {
                this.state.category === 'JUSTIFIED_DELAY' ||
                  this.state.category === 'MISSING_TIME' ||
                  this.state.category === 'OUTPUT_SERVICE' ||
                  this.state.category === 'DECLARATION_ATTENDANCE' ?
                  (
                    <Input
                      elementType="timePicker"
                      label={this.state.category == "MISSING_TIME" ? "Hora falta" : "Horas abonadas"}
                      margin="normal"
                      value={this.state.allowanceHours ? this.state.allowanceHours : null
                      }
                      onChange={event => this.handleInputChange(event, 'allowanceHours')}
                    />
                  ) : ''
              }
              {
                this.state.category === 'DECLARATION_ATTENDANCE' ?

                  <div style={{ width: '400px' }}>
                    <Input
                      elementType="select"
                      value={this.state.reduces}
                      onChange={event => {
                        this.setState({ reduces: event.target.value })
                      }
                      }
                      label="De onde compensar?"
                      options={typesReduce}
                      margin="normal"
                      required
                      fullWidth
                    />
                  </div> : ''
              }
              {
                this.state.category === 'HOME_OFFICE' ?

                  <div style={{ width: '400px' }}>
                    <Input
                      elementType="select"
                      value={this.state.homeOffice}
                      onChange={event => {
                        this.setState({ homeOffice: event.target.value })
                      }}
                      label="Escolher carga horária"
                      options={typesHome}
                      margin="normal"
                      required
                      fullWidth
                    />
                  </div> : ''
              }
              {
                this.state.category === 'LEAVE_OF_ABSENCE' ?

                  <div style={{ width: '400px' }}>

                    <Input
                      elementType="select"
                      value={this.state.valueObservation}
                      onChange={event => {
                        if (event.target.value == 'outro') {
                          this.setState({ observation: true })
                        } else {
                          this.handleInputChange(event, 'observation')
                          this.setState({ valueObservation: event.target.value })
                          this.setState({ observation: false })
                        }
                      }}
                      label="Observação"
                      options={observations}
                      margin="normal"
                      fullWidth
                    >
                    </Input>

                  </div> : ''
              }

            </div>

          </DialogContent>

          <DialogActions>
            <Button onClick={this.handleAbonoClose}>CANCELAR</Button>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={this.confirmAllowance}
              disabled={!this.state.buttonConfirm}
            >
              CONFIRMAR
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  };

  getDateAsMinutes = (date) => {
    const hours = getHours(date);
    const minutes = getMinutes(date);
    return (hours * 60) + minutes;
  }

  confirmAllowance = () => {
    const expectedRule = this.expectedRule()
    const info = {
      dtFrom: this.props.detailed.typeDay.dtRef,
      dtTo: this.props.detailed.typeDay.dtRef,
      category: this.state.category,
      observation: this.state.category == 'LEAVE_OF_ABSENCE' ? this.state.valueObservation : this.state.observation,
      compensationDate: this.state.compensationDate,
      allowanceHours: this.state.allowanceHours && this.getDateAsMinutes(this.state.allowanceHours),
      expectedRule: expectedRule,
      employees: [this.props.worker.id],
    };

    this.props.onCreateVacations(info)
      .then(() => {
        this.handleAbonoClose();
        this.props.close();
      });

  }

  handleValidateClose = () => {
    this.setState({ openValidate: false });
  };

  renderValidateModal = () => {
    const { classes } = this.props;

    return (
      <Dialog
        open={this.state.openValidate}
        onClose={this.handleValidateClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Validar Pontos</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Informe uma justificativa para a validação dos pontos desse dia.
          </DialogContentText>
          <TextField
            required
            label="Justificativa"
            value={this.state.justification}
            onChange={this.handleJustificationChange}
            className={classNames(classes.textField, classes.dense)}
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleValidateClose}>CANCELAR</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!this.state.justification.length}
            onClick={() => this.validate()}
          >
            CONFIRMAR
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderMarcarFalta = () => {
    const { classes } = this.props;
    return (
      <Dialog
        open={this.state.openFalta}
        onClose={this.handleFaltaClose}
        aria-labelledby="form-dialog-title"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle id="form-dialog-title">Marcar Falta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Informe uma justificativa para considerar este dia como uma falta.
          </DialogContentText>
          <TextField
            required
            label="Justificativa"
            value={this.state.justification}
            onChange={this.handleJustificationChange}
            className={classNames(classes.textField, classes.dense)}
            margin="dense"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleFaltaClose}>CANCELAR</Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!this.state.justification.length}
            onClick={() => this.marcarFalta()}
          >
            CONFIRMAR
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  marcarFalta = () => {
    this.actions = [];

    const action = {
      action: 'FAL',
      dtRegister: this.props.detailed.typeDay.dtRef,
      justification: this.state.justification,
    };

    this.actions.push(action);
    this.finishActions();
    this.forceUpdate();
  }

  handleFaltaClose = () => {
    this.setState({ openFalta: false });
  };


  undoAction = (ponto) => {
    let target = this.actions.filter(a => a.id === ponto.id);

    if (target.length) {
      target = target[0];

      const index = this.actions.map(a => a.id).indexOf(target.id);


      this.actions.splice(index, 1);

      this.forceUpdate();
    }
    return ponto;
  }

  renderBankDetails = () => (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '10px' }}>
      <span>
        Saldo: {this.props.detailed.balances && this.props.detailed.balances.daily ? this.props.detailed.balances.daily.balanceDailyFormated : '00:00'}
      </span>
      {
        this.props.detailed.extras && this.props.detailed.extras.hasBankHours ?
          <span>
            Banco de horas: {this.props.detailed.balances.bankHours.balanceBankHoursFormated}
          </span> :
          null
      }
      <span>
        Horas extras: {this.props.detailed.balances ? this.props.detailed.balances.extraHours.balanceExtraHoursFormated : '00:00'}
      </span>
    </div>
  )

  minuteToHour = (m) => {
    if (typeof m === 'string' && m.length >= 2) {
      return m;
    }
    const signal = m < 0 ? '-' : (this.props.positive ? '+' : '');

    if (m < 0) {
      m *= -1;
    }

    if (m !== 0) {
      let hours = Math.floor(m / 60);
      let minutes = m % 60;
      if (hours < 10) {
        hours = `0${hours} `;
      }
      if (minutes < 10) {
        minutes = `0${minutes} `;
      }
      return `${signal + hours}:${minutes} `;
    }
    return '00:00';
  }

  aproveAll = () => {
    this.actions = [];

    let allPoints = [];
    allPoints = this.entradasOff.concat(this.saidasOff);
    allPoints.map((point) => {
      const action = {
        action: 'OFF',
        id: point.id,
        isRemake: point.isRemake,
        dtRegister: this.fixTimestamp(point.dtRegister),
      };

      return this.actions.push(action);
    });

    this.forceUpdate();
  }

  removeAll = () => {
    this.actions = [];

    let allPoints = [];
    allPoints = this.entradasOff.concat(this.saidasOff);
    allPoints.map((point) => {
      const action = {
        action: 'REM',
        id: point.id,
        justification: 'Ponto offline recusado',
        isRemake: point.isRemake,
        dtRegister: this.fixTimestamp(point.dtRegister),
      };

      return this.actions.push(action);
    });

    this.forceUpdate();
  }

  isPremium = () => {
    const validaetPremium = JSON.parse(localStorage.getItem('privileges')).isExportAfd;
    if (validaetPremium === false) {
      this.setState({ premium: false });
    } else {
      this.setState({ premium: true });
    }
  }


  renderOfflinePoints = () => {
    const { classes } = this.props;
    // eslint-disable-next-line eqeqeq
    // eslint-disable-next-line no-bitwise
    // eslint-disable-next-line eqeqeq
    if (this.props.hasOffline == undefined || this.props.hasOffline == false) {
      return null;
    }

    if (this.state.validaetPremium) {
      return (<div>
        <div style={{
          display: 'flex', justifyContent: 'space-between', marginTop: 20, marginBottom: 30,
        }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }} >
            <Typography
              variant="h6"
              style={{
                color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
              }}
            >
              Pontos offline pendentes
            </Typography>
          </div>
          <div>
            <Button color="primary" onClick={() => { this.aproveAll(); }} >Aprovar todos <Done /> </Button>
            <Button color="primary" onClick={() => { this.removeAll(); }} > Recusar todos <Clear /> </Button>
          </div>


        </div>

        <div className={classNames(classes.quadColumnContainer)}>
          <div className={classNames(classes.quadContentColumn)}>

            <Typography
              variant="body1"
              style={{
                color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
              }}
            >
              Entradas
            </Typography>

            <DaysHoursOff
              hours={this.entradasOff}
              edit={this.editHour}
              remove={this.remove}
              aprove={this.aproveOff}
              validate={this.validate}
              actions={this.actions}
              undoAction={this.undoAction}
              blockActions={this.props.detailed.mock}
            />
          </div>

          <div className={classNames(classes.quadContentColumn)}>
            <Typography
              variant="body1"
              style={{
                color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
              }}
            >
              Saídas
            </Typography>
            <DaysHoursOff
              hours={this.saidasOff}
              edit={this.editHour}
              remove={this.remove}
              aprove={this.aproveOff}
              validate={this.validate}
              actions={this.actions}
              undoAction={this.undoAction}
              blockActions={this.props.detailed.mock}
            />
          </div>
        </div>
        <span style={{ fontSize: '0.875em', color: 'gray' }}>*O Puntu não se responsabiliza pela veracidade
          do ponto offline
        </span>
      </div>);
    } else {
      return (
        <Paper style={{ textAlign: 'center', padding: '20px' }}>
          <Typography
            variant="h6"
            style={{
              color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
            }}
          >
            Pontos offline pendentes
          </Typography>
          <Link style={{ textDecoration: 'none' }} to="/assinatura">
            <Typography color="primary" className={classes.premium}>
              Seja assinante e trate os pontos offline sempre que precisar.
            </Typography>
          </Link>
        </Paper>
      )
    }
  }
  render() {
    if (this.props.detailed) {
      const { classes } = this.props;
      this.buildDataInfo();
      this.buildMessages();

      return (
        <div className="day-modal" style={{ padding: '15px' }}>
          <div id="modal-title">
            {this.renderTitle()}
          </div>
          <div className={classes.infoDetails}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              {this.renderDayDetails()} <br />


              <Tooltip
                style={{ color: '#e00000', fontSize: '20px' }}
                classes={{ tooltip: classes.lightTooltip }}
                title={this.renderBankDetails()}
                aria-label="Divergências"
                placement="top"
              >
                <Card style={{ marginLeft: 'auto' }}>
                  <div style={{ padding: '6px' }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <Typography>
                        {
                          this.props.detailed.balances && this.props.detailed.balances.worked ? this.props.detailed.balances.worked.balanceWorkedFormated : '00:00'
                        }
                      </Typography>
                      <Icon style={{ marginLeft: 'auto', fontSize: '16px', color: '#537ccd' }}>info</Icon>
                    </div>

                    <Typography variant="subtitle2" color="textSecondary"> Horas trabalhadas</Typography>
                  </div>
                </Card>
              </Tooltip>

            </div>

          </div>

          <div className={classNames(classes.quadColumnContainer)}>
            <div className={classNames(classes.quadContentColumn)}>
              <Typography
                variant="body1"
                style={{
                  color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
                }}
              >
                Entradas
              </Typography>

              <DayHours
                modalPicture={this.modalPicture}
                hours={this.entradas}
                asCheckpoint={this.asCheckpoint}
                edit={this.editHour}
                remove={this.remove}
                validate={this.validate}
                actions={this.actions}
                undoAction={this.undoAction}
                blockActions={this.props.detailed.mock}
              />
            </div>

            <div className={classNames(classes.quadContentColumn)}>
              <Typography
                variant="body1"
                style={{
                  color: 'rgba(0, 0, 0, 0.54)', marginBottom: '0.25em',
                }}
              >
                Saídas
              </Typography>
              <DayHours
                modalPicture={this.modalPicture}
                hours={this.saidas}
                asCheckpoint={this.asCheckpoint}
                edit={this.editHour}
                remove={this.remove}
                validate={this.validate}
                actions={this.actions}
                undoAction={this.undoAction}
                blockActions={this.props.detailed.mock}
              />
            </div>
          </div>

          {this.renderOfflinePoints()}
          {/* {this.props.hasOffline ?
            :
           
          } */}


          {this.renderFinish()}
          {this.renderConfirm()}
          {this.addPonto()}
          {this.renderConfirmAbono()}
          {this.renderValidateModal()}
          {this.renderMarcarFalta()}

          <div >
            {!this.state.validaetPremium ?
              <Dialog
                open={this.state.openDialogPicture}
                onClose={this.onCloseModalPicture}
              >
                <DialogTitle>Atenção</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    <Typography color="primary" className={classes.premium}>
                      Seja assinante e tenha acesso as opções de visualizar e baixar a foto do ponto.
                    </Typography>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="primary" onClick={() => this.onCloseModalPicture()}>
                    Fechar
                  </Button>
                  <Button component={Link} to="/assinatura" onClick={this.handleClose} variant="contained" color="primary" autoFocus>
                    Assinar
                  </Button>
                </DialogActions>
              </Dialog>
              : this.state.error ?
                <Dialog
                  open={this.state.errorPicture}
                  onClose={this.errorPictureClose}
                >
                  <DialogTitle style={{ textAlign: 'center', width: 600 }}>Local do Ponto</DialogTitle>
                  <Map
                    center={[this.state.latitude, this.state.longitude]}
                    zoomControl={true}
                    zoom={17}
                    style={{ height: 500, margin: '0 auto', width: '100%', alignItems: 'center' }}
                  >
                    <TileLayer
                      attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                      position={[this.state.latitude, this.state.longitude]}
                      icon={this.state.Type === 'I' ? iconIn : (this.state.Type === 'O' ? iconOut : iconAllowed)}
                      popupAnchor={[0, -41]}
                    ></Marker>
                  </Map>
                </Dialog>

                // <Dialog
                //   open={this.state.errorPicture}
                //   onClose={this.errorPictureClose}
                // >

                /* <ErrorOutline
                  style={{
                    display: 'flex',
                    margin: '20px auto 10px auto',
                    width: '89px',
                    height: '89px',
                    color: '#537ccd',
                  }} />
                <DialogTitle style={{ textAlign: 'center' }}>Esse ponto não possui foto.</DialogTitle></Dialog> */
                :
                <Dialog
                  open={this.state.modalPicture}
                  onClose={this.modalPicture}
                >
                  <DialogTitle style={{ textAlign: 'center', width: 600 }}> Ponto com foto</DialogTitle>
                  <DialogContent style={{ textAlign: '-webkit-center', width: '100%' }}>
                    <DialogContentText>
                      {this.state.namePicture} - {(moment(this.state.dataPicture, 'YYYY-MM-DD HH:mm:ss').locale('pt-br').format('DD/MM/yyyy'))} - {this.state.typePicture == 'I' ? 'Entrada' : 'Saida'} - {this.state.hourPicture}
                    </DialogContentText>
                    <CardMedia
                      component="img"
                      image={this.state.fotoModal}
                    />
                  </DialogContent>
                  <DialogActions style={{ justifyContent: 'center' }}>
                    <Button color="primary" onClick={() => this.downloadPicture(this.state.fotoModal)}>
                      Baixar foto
                    </Button>
                  </DialogActions>
                  <DialogTitle style={{ textAlign: 'center', width: 600 }}>Local do Ponto</DialogTitle>
                  <Map
                    center={[this.state.latitude, this.state.longitude]}
                    zoomControl={true}
                    zoom={17}
                    style={{ height: 400, margin: '0 auto', width: '100%', alignItems: 'center' }}
                  >
                    <TileLayer
                      attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker
                      position={[this.state.latitude, this.state.longitude]}
                      icon={this.state.Type === 'I' ? iconIn : (this.state.Type === 'O' ? iconOut : iconAllowed)}
                      popupAnchor={[0, -41]}
                    ></Marker>

                  </Map>
                </Dialog>
            }
          </div>
        </div >
      );
    }

    return (
      <div />
    );
  }
}
// export default withStyles(styles)(CalendarModalContent);

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onCreateVacations: vacation => dispatch(createVacations(vacation)),
  onMessage: message => dispatch(setMessage(message)),
});

export const StyledComponent = withStyles(styles)(CalendarModalContent);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(StyledComponent));
